export const UPDATE_USERS = 'UPDATE_USERS';
export const UPDATE_FULL_USERS = 'UPDATE_FULL_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const CLEAR_EDITED_USER = 'CLEAR_EDITED_USER';
export const UPDATE_USER_SEARCH_FORM = 'UPDATE_USER_SEARCH_FORM';
export const UPDATE_FORM_USER = 'UPDATE_FORM_USER';
export const GET_USER = 'GET_USER';
export const UPDATE_FORM_USER_LICO_ID = 'UPDATE_FORM_USER_LICO_ID';
